var _a;
import { Language } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import translationsEn from '../locales/en/translation.json';
import translationsFr from '../locales/fr/translation.json';
import translationsJa from '../locales/ja/translation.json';
import translationsRu from '../locales/ru/translation.json';
i18n
    .use(detector)
    .use(initReactI18next)
    .init({
    resources: (_a = {},
        _a[Language.EN] = {
            translation: translationsEn,
        },
        _a[Language.FR] = {
            translation: translationsFr,
        },
        _a[Language.JA] = {
            translation: translationsJa,
        },
        _a[Language.RU] = {
            translation: translationsRu,
        },
        _a),
    fallbackLng: Language.EN,
    saveMissing: true,
    debug: true,
    fallbackNS: Language.EN,
});
export default i18n;
